import { useQuery, useMutation, useQueryClient } from "react-query";
import { fetchData } from "../api/client";

/** Busca clientes por estágio (função assíncrona, não é hook). */
export const getClientsByStage = async (stageId, page = 1, limit = 50) => {
  const response = await fetchData(
    `/clients?stageId=${stageId}&page=${page}&limit=${limit}`,
    "GET"
  );
  const list = response?.data ?? response ?? [];
  return Array.isArray(list) ? list : [];
};

/**
 * @param {number} [page=1]
 * @param {number} [limit=10]
 * @param {string} [search=""]
 * @param {number|number[]|string|null} [idsProjetos] - quando informado, filtra clientes pela(s) empresa(s); na URL para não ser sobrescrito pelo interceptor
 * @param {object} [options] - opções adicionais do react-query (ex.: enabled, staleTime extra, etc.)
 */
export const useClients = (page = 1, limit = 10, search = "", idsProjetos = null, options = {}) => {
  const queryClient = useQueryClient();

  const effectiveSearch =
    typeof search === "string" && search.trim().length >= 2 ? search : "";

  const idsProjetosParam = (() => {
    if (idsProjetos == null) return "";
    if (Array.isArray(idsProjetos)) return idsProjetos.filter((n) => Number.isFinite(Number(n))).join(",");
    if (typeof idsProjetos === "number" && Number.isFinite(idsProjetos)) return String(idsProjetos);
    const s = String(idsProjetos).trim();
    return s ? s : "";
  })();

  const url =
    `/clients?page=${page}&limit=${limit}&search=${encodeURIComponent(effectiveSearch)}` +
    (idsProjetosParam ? `&ids_projetos=${encodeURIComponent(idsProjetosParam)}` : "");

  const query = useQuery(
    ["clients", page, limit, search, idsProjetosParam],
    () => fetchData(url),
    {
      staleTime: 5000,
      refetchOnWindowFocus: false,
      select: (response) => ({
        clients: response && response.data ? response.data : [],
        pagination: (response && response.pagination) || { total: 0 },
      }),
      ...(options || {}),
    }
  );

  const updateMutation = useMutation(
    (client) => {
      const method = client.id ? "PUT" : "POST";
      const endpoint = client.id ? `/clients/${client.id}` : `/clients`;
      return fetchData(endpoint, method, client);
    },
    {
      onSuccess: () => queryClient.invalidateQueries("clients"),
    }
  );

  const deleteMutation = useMutation(
    (id) => fetchData(`/clients/${id}`, "DELETE"),
    {
      onSuccess: () => queryClient.invalidateQueries("clients"),
    }
  );

  return { ...query, updateMutation, deleteMutation };
};
